import { Stack } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Shimmer } from '@component/new_shimmer.component';
import { Fragment } from 'react';

export function CookiePolicySkeleton(): JSX.Element {
	return (
		<Fragment>
			<Shimmer height={45} width={150} />
			<Stack gap={tokens.spacing.x1}>
				<Shimmer height={10} width={100} />
				<Shimmer height={10} width={300} />
				<Shimmer height={10} width={200} />
				<Shimmer height={10} width={300} />
				<Shimmer height={10} width={100} />
				<Shimmer height={10} width={200} />
				<Shimmer height={10} width={300} />
				<Shimmer height={10} width={200} />
			</Stack>
			<Stack gap={tokens.spacing.x1}>
				<Shimmer height={30} width={100} />
				<Shimmer height={10} width={150} />
				<Shimmer height={10} width={200} />
				<Shimmer height={10} width={200} />
				<Shimmer height={10} width={250} />
				<Shimmer height={10} width={200} opacity={0.9} />
				<Shimmer height={10} width={100} opacity={0.9} />
				<Shimmer height={10} width={100} opacity={0.9} />
				<Shimmer height={10} width={200} opacity={0.9} />
			</Stack>
			<Stack gap={tokens.spacing.x1}>
				<Shimmer height={30} width={250} opacity={0.9} />
				<Shimmer height={10} width={150} opacity={0.8} />
				<Shimmer height={10} width={200} opacity={0.7} />
				<Shimmer height={10} width={250} opacity={0.6} />
				<Shimmer height={10} width={100} opacity={0.5} />
				<Shimmer height={10} width={200} opacity={0.4} />
				<Shimmer height={10} width={150} opacity={0.3} />
				<Shimmer height={10} width={100} opacity={0.2} />
				<Shimmer height={10} width={200} opacity={0.1} />
			</Stack>
		</Fragment>
	);
}
